import type { IMeta } from '@models/IMeta';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import classNames from 'classnames';

interface Props {
  readonly title?: string;
  readonly cards: {
    readonly title: string;
    readonly body?: string;
    readonly meta?: IMeta;
  }[];
  readonly meta?: IMeta;
}

const FeatureCardsList = ({ title, cards, meta }: Props) => {
  const displayStyles =
    cards.length === 5
      ? 'lg:grid-cols-3 xl:flex xl:flex-row'
      : 'lg:flex lg:flex-row lg:items-center lg:justify-center';

  const CardListTitleTag = title ? 'h3' : 'p';

  return (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-167-Feature-Cards-List"
    >
      <SoftLoadWrapper>
        <div className="container flex flex-col items-center justify-center gap-10">
          {title && (
            <h2
              className="w-4/5 text-center"
              data-testid="CT-167-Feature-Cards-List-Title"
              data-epi-property-name={meta?.editHints?.title}
            >
              {title}
            </h2>
          )}
          <div
            className={classNames(
              'flex flex-col gap-4 md:grid md:grid-cols-2',
              displayStyles
            )}
            data-epi-property-name={meta?.editHints?.cards}
          >
            {cards.map(({ title: cardTitle, body }, index) => (
              <div
                key={cardTitle}
                className="flex max-w-[800px] flex-1 flex-col items-center gap-2 rounded-[5px] bg-grey-600 px-4 py-6 lg:flex-1 lg:self-stretch lg:px-6 lg:py-10"
                data-testid={`CT-167-Feature-Cards-List-Card-${index}`}
              >
                <CardListTitleTag
                  className="h6 text-center text-white"
                  data-testid={`CT-167-Feature-Cards-List-Card-${index}-Title`}
                >
                  {cardTitle}
                </CardListTitleTag>
                {body && (
                  <div
                    className="body-two text-center text-grey-500"
                    dangerouslySetInnerHTML={{ __html: body }}
                    data-testid={`CT-167-Feature-Cards-List-Card-${index}-Body`}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default FeatureCardsList;
